export enum PROMPTS {
  FIRST_TIME_JOINING = 'FIRST_TIME_JOINING',
  JOIN_CALL = 'JOIN_CALL',
  HELPER_GUIDE = 'HELPER_GUIDE',
  SPACE_DEVICE_MODAL = 'SPACE_DEVICE_MODAL',
}
